import React from "react";
import { Form, Input, Button, Spin } from "antd";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { getTranslation } from "../../../utils/helper";

const GroupForm = ({ form, isFetching, group, handleSubmit, handleCancel }) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;
  return (
    <Spin spinning={isFetching}>
      <div className="GroupForm">
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
          <div className="FormHeader">
            <div className="left">
              {group
                ? getTranslation(setting, "User Groups", "Edit Group")
                : getTranslation(setting, "User Groups", "New Group")}
            </div>
          </div>
          <div className="FormContent">
            <Form.Item
              label={getTranslation(setting, "User Groups", "Group Name")}
              name="name"
              rules={[{ required: true, message: "Required" }]}>
              <Input size="large" placeholder={getTranslation(setting, "User Groups", "Group Name")} />
            </Form.Item>
          </div>
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <Button key="cancel" onClick={handleCancel}>
                {getTranslation(setting, "Common", "Cancel")}
              </Button>
              <Button htmlType="submit" type="primary">
                {group ? getTranslation(setting, "Common", "Update") : getTranslation(setting, "Common", "Create")}
                <ReactSVG className="icon" src="/icons/submit.svg" />
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default GroupForm;
